/** @jsx jsx */
import { PageProps } from "gatsby"
import { useState } from "react"
import { Box, Container, Heading, jsx, Paragraph } from "theme-ui"

import BackgroundSVG from "images/icons/background-light.svg"

import AguilaButton from "components/AguilaButton"
import BannerHero from "components/BannerHero"
import Layout from "components/Layout"

interface MyFormValues {
  full_name: string
  email: string
  phone?: string
  contact_dept: string
  message?: string
}
interface ICustomFormValues {
  heading: string
  subHeading: string
  introParagraph: string
  contactDetails: string
}

interface IFormVariations {
  gov_law: ICustomFormValues
  sponsor_partner: ICustomFormValues
  gen_inquiries: ICustomFormValues
  careers: ICustomFormValues
}

const ProductSupportPage = ({ location }: PageProps) => {
  const params = new URLSearchParams(location.search)
  let contactDept = params.get("dept")
  contactDept = contactDept ? contactDept : "gen_inquiries"

  const [formSuccess, setFormSuccess] = useState(false)

  return (
    <Layout seo={{ metaTitle: "Product Support" }} location={location}>
      <Box sx={{ position: "relative" }}>
        <BackgroundSVG
          sx={{
            position: "absolute",
            zIndex: -1,
            transformOrigin: "center",
            top: 0,
            left: 0,
            width: "auto",
            minHeight: "500px",
            height: "100%",
            transform: "translate(-40%, 0)",
            "& > g": {
              opacity: 0.2,
            },
            "& *": {
              fill: "#d6d1c4cf",
            },
          }}
        />
        <BannerHero
          heading={"Product Support"}
          // subHeading={formContent.subHeading}
          // content={formContent.introParagraph}
        />
        <Box
          as="section"
          sx={{
            position: "relative",
            mb: [16, null, null, 36],
            mt: ["-140px", null, null, "-240px"],
          }}
        >
          <Container
            variant="layout.narrow"
            sx={{ backgroundColor: "lightTan", boxShadow: 0 }}
          >
            {!formSuccess && (
              <Box
                sx={{
                  mx: "auto",
                  py: 18,
                  px: 18,
                  width: "100%",
                }}
              >
                <iframe
                  src="https://forms.monday.com/forms/embed/65ba1b1200adaf441e3244a53f2dc95f?r=use1"
                  width="100%"
                  height="600"
                  sx={{ border: "none" }}
                  // style="border: 0; box-shadow: 5px 5px 56px 0px rgba(0,0,0,0.25);"
                ></iframe>
              </Box>
            )}
            {formSuccess && (
              <Box
                sx={{
                  mx: "auto",
                  py: 18,
                  maxWidth: "520px",
                  width: "100%",
                  minHeight: "350px",
                }}
              >
                <Heading as="h2" variant="title">
                  Thanks for contacting us
                </Heading>
                <Paragraph sx={{ mb: 8 }}>
                  We’ll be in touch soon. In the meantime, check out some of our
                  ammo!
                </Paragraph>
                <AguilaButton url="/ammunition/all" text="View products" />
              </Box>
            )}
          </Container>
        </Box>
      </Box>
    </Layout>
  )
}

export default ProductSupportPage
